import posthog from 'posthog-js';

export default {
  install(app) {
    if (import.meta.env.VITE_ENV !== 'production') return;
    app.config.globalProperties.$posthog = posthog.init(
      'phc_KsrqWqSPt1cdDxHbxHuZbI9H5pa2GCytitMzsQM1bR1',
      {
        api_host: 'https://us.i.posthog.com',
        persistence: 'cookie',
        cookie_domain: '.kairos.rocks'
      }
    );
  }
};
